import { CreneauType } from '../../app.constants';
import { InvalidCreneauException } from '../../shared/exceptions/invalid-creneau.exception';
import { CreneauGardiennage } from './creneau-gardiennage.model';
import { CreneauInterPonctuelle } from './creneau-inter-ponctuelle.model';
import { CreneauIntervention } from './creneau-intervention.model';
import { CreneauRonde } from './creneau-ronde.model';
import { CreneauTournee } from './creneau-tournee.model';
import { ICreneau } from './creneau.interface';
import { ParametresMobiles } from './parametres-mobiles.model';

export class ProchainsCreneaux {
  constructor(
    public courant: ICreneau | null = null,
    public prochains: ICreneau[] = [],
    public parametresMobiles: ParametresMobiles = new ParametresMobiles()
  ) {}

  public static hydrate(obj: any): ProchainsCreneaux {
    return new ProchainsCreneaux(
      obj.courant ? ProchainsCreneaux.hydrateCreneau(obj.courant) : null,
      obj.prochains ? obj.prochains.map(ProchainsCreneaux.hydrateCreneau) : [],
      obj.parametresMobiles ? ParametresMobiles.hydrate(obj.parametresMobiles) : new ParametresMobiles()
    );
  }

  private static hydrateCreneau(obj: ICreneau): ICreneau {
    switch (obj.type) {
      case CreneauType.GARDIENNAGE:
        return CreneauGardiennage.hydrate(obj as CreneauGardiennage);
      case CreneauType.INTERVENTION:
        return CreneauIntervention.hydrate(obj as CreneauIntervention);
      case CreneauType.TOURNEE:
        return CreneauTournee.hydrate(obj as CreneauTournee);
      case CreneauType.RONDE:
        return CreneauRonde.hydrate(obj as CreneauRonde);
      case CreneauType.INTER_PONCTUELLE:
        return CreneauInterPonctuelle.hydrate(obj as CreneauInterPonctuelle);
      default:
        throw new InvalidCreneauException(`Creneau inconnu ${obj.type}`);
    }
  }
}
